import { useContext, useRef, useState } from 'react';
import ReactCardFlip from 'react-card-flip';
import { DataContext } from 'providers/data';
import { useReactToPrint } from 'react-to-print';
import { Modal, Box, Typography } from "@mui/material";

import LabelDetails from './LabelDetails';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';

import { ReactComponent as IcHeadset } from 'assets/icons/ic-headset.svg';
import { ReactComponent as IcFlipCard } from 'assets/icons/ic-flip-card.svg';
import { ReactComponent as IcLogoIturan } from 'assets/icons/ic-logo-ituran.svg';
import { ReactComponent as IcClosedCircle } from 'assets/icons/ic-closed-circle.svg';
import { ReactComponent as IcMapCustomerCard } from 'assets/icons/ic-map-customer-card.svg';

import { BoxCard, ContentCards, ButtonSvg } from './styles';

type Params = {
    open: boolean;
    handleClick: (value: boolean) => void;
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: '0px 4.51039px 5.63799px rgba(0, 0, 0, 0.18)',
    width: {
        xs: '95%',
        md: '51.75rem'
    },
    display: 'flex',
    flexDirection: 'column',
    padding: '.75rem .5rem 0',
    borderRadius: '5px 5px 0 0',
    borderBottom: '13px solid #0C1C33',
    outline: 'none'
};

const styleGrid = {
    display: 'grid',
    justifyContent: 'space-between',
    gridTemplateColumns: '10rem 7rem'
};

const ModalCustomerCard = ({ open, handleClick }: Params) => {
    const [btnFlip, setBtnFlip] = useState(false);
    const printRef = useRef<HTMLDivElement>(null);
    const { customerCard } = useContext(DataContext);

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    });

    return (
        <Modal open={open}>
            <Box sx={style}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <ButtonSvg
                        onClick={() => handleClick(false)}
                        sx={{
                            border: 'none',
                            padding: {
                                xs: '0 .2rem',
                                md: '.75rem'
                            },
                            minWidth: '2rem',
                            backgroundColor: 'transparent'
                        }}>
                        <IcClosedCircle />
                    </ButtonSvg>
                </Box>
                <Box sx={{
                    paddingTop: {
                        xs: '.5rem',
                        md: '1.56rem'
                    }
                }}>
                    <Typography fontSize='1.26rem' textAlign='center' fontWeight={700}>
                        CARTÃO DO CLIENTE
                    </Typography>
                    <ContentCards>
                        <ButtonSvg sx={{
                            position: 'absolute',
                            right: '8px',
                            bottom: '44%',
                            borderRadius: '100px',
                            backgroundColor: 'secondary.main',
                            minWidth: '3rem',
                            minHeight: '3rem',
                            zIndex: '3',
                            border: '1.5px solid #FFFFFF',
                            '&:hover': {
                                backgroundColor: 'secondary.main',
                            },
                            display: {
                                xs: 'grid',
                                md: 'none'
                            }
                        }}
                            onClick={() => setBtnFlip(!btnFlip)}>
                            <IcFlipCard />
                        </ButtonSvg>

                        <Box sx={{
                            display: {
                                xs: 'block',
                                md: 'none'
                            }
                        }}>
                            <ReactCardFlip isFlipped={btnFlip} flipDirection="horizontal">
                                <Box>
                                    <BoxCard className='front-mob'>
                                        <IcMapCustomerCard />
                                        <Box sx={{ padding: '1.75rem 2.1875rem', display: 'flex', height: '100%', flexDirection: 'column' }}>
                                            <Box sx={{ display: 'flex', height: '2.625rem', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <IcLogoIturan style={{ position: 'relative', width: 'auto', height: '100%' }} />
                                                <Box sx={{
                                                    gap: '2px',
                                                    display: 'flex',
                                                    width: '8.25rem',
                                                    height: '2.06rem',
                                                    borderRadius: '1rem',
                                                    alignItems: 'center',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    border: '1.43246px solid #FFFFFF'
                                                }}>
                                                    <Typography fontSize='.3125rem' fontWeight={700} color='white'>
                                                        NÚMERO DO ASSINANTE
                                                    </Typography>
                                                    <Typography fontSize='.875rem' fontWeight={900} color='white'>
                                                        {customerCard?.policyDescription}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            {customerCard &&
                                                <Box sx={{ paddingTop: '1.5625rem', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                                                    <Box sx={styleGrid}>
                                                        <LabelDetails name='NOME' valeu={customerCard?.personName} />
                                                        <LabelDetails name='CPF' valeu={customerCard?.personDocument} />
                                                    </Box>
                                                    <Box sx={styleGrid}>
                                                        <LabelDetails name='MODELO DO VEÍCULO' valeu={customerCard?.modelName} />
                                                        <LabelDetails name='PLACA' valeu={customerCard?.plate} />
                                                    </Box>
                                                    <Box sx={styleGrid}>
                                                        <LabelDetails name='CHASSI' valeu={customerCard?.chassis} />
                                                        <LabelDetails name='NÚMERO DA APÓLICE' valeu={customerCard?.policyNumber} />
                                                    </Box>
                                                </Box>
                                            }
                                        </Box>
                                    </BoxCard>
                                </Box>
                                <Box>
                                    <BoxCard className='back-mob'>
                                        <IcMapCustomerCard />
                                        <Box padding='1.7rem 0 .75rem'>
                                            <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', gap: '.5rem' }}>
                                                <IcHeadset style={{ position: 'relative', width: 'auto', maxHeight: '1.5rem' }} />
                                                <Typography fontSize='.75rem' fontWeight={700} color='white'>
                                                    ROUBO E FURTO
                                                </Typography>
                                                <Typography fontSize='1.51rem' fontWeight={900} color='white'>
                                                    {customerCard?.EmergencyPhone}
                                                </Typography>
                                            </Box>
                                            <Box sx={{
                                                height: '1px',
                                                width: '1.31rem',
                                                margin: '1rem auto 1.2rem',
                                                borderRadius: '100px',
                                                justifyContent: 'center',
                                                backgroundColor: 'secondary.main',
                                            }} />
                                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: '.8rem' }}>
                                                <Box>
                                                    <Typography fontSize='.4375rem' fontWeight={700} color='white' paddingBottom='4px'>
                                                        SÃO PAULO
                                                    </Typography>
                                                    <Typography fontSize='.75rem' fontWeight={900} color='white'>
                                                        {customerCard?.SACPhoneSP}
                                                    </Typography>
                                                </Box>

                                                <Box>
                                                    <Typography fontSize='.4375rem' fontWeight={700} color='white' paddingBottom='4px'>
                                                        DEMAIS LOCALIDADES
                                                    </Typography>
                                                    <Typography fontSize='.75rem' fontWeight={900} color='white'>
                                                        {customerCard?.SACPhoneOthers}
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            <Typography fontSize='.4375rem' fontWeight={700} color='white' sx={{
                                                position: 'absolute',
                                                bottom: '.75rem',
                                                display: 'flex',
                                                left: '0',
                                                right: '0',
                                                justifyContent: 'center',
                                            }}>
                                                WWW.ITURAN.COM.BR
                                            </Typography>
                                        </Box>
                                    </BoxCard>
                                </Box>
                            </ReactCardFlip>
                        </Box>

                        <Box sx={{
                            width: '100%',
                            display: {
                                xs: 'none',
                                md: 'block',
                            }
                        }}>
                            <Box sx={{
                                width: '100%',
                                padding: '0 2rem',
                                justifyContent: 'center',
                                display: 'flex'
                            }}
                                ref={printRef}>
                                <BoxCard className='front-desk'>
                                    <IcMapCustomerCard />
                                    <Box sx={{ padding: '1.75rem 2.1875rem', display: 'flex', height: '100%', flexDirection: 'column' }}>
                                        <Box sx={{ display: 'flex', height: '2.625rem', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <IcLogoIturan style={{ position: 'relative', width: 'auto', height: '100%' }} />
                                            <Box sx={{
                                                gap: '2px',
                                                display: 'flex',
                                                width: '8.25rem',
                                                height: '2.06rem',
                                                borderRadius: '1rem',
                                                alignItems: 'center',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                border: '1.43246px solid #FFFFFF'
                                            }}>
                                                <Typography fontSize='.3125rem' fontWeight={700} color='white'>
                                                    NÚMERO DO ASSINANTE
                                                </Typography>
                                                <Typography fontSize='.875rem' fontWeight={900} color='white'>
                                                    {customerCard?.policyDescription}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        {customerCard &&
                                            <Box sx={{ paddingTop: '1.5625rem', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                                                <Box sx={styleGrid}>
                                                    <LabelDetails name='NOME' valeu={customerCard?.personName} />
                                                    <LabelDetails name='CPF' valeu={customerCard?.personDocument} />
                                                </Box>
                                                <Box sx={styleGrid}>
                                                    <LabelDetails name='MODELO DO VEÍCULO' valeu={customerCard?.modelName} />
                                                    <LabelDetails name='PLACA' valeu={customerCard?.plate} />
                                                </Box>
                                                <Box sx={styleGrid}>
                                                    <LabelDetails name='CHASSI' valeu={customerCard?.chassis} />
                                                    <LabelDetails name='NÚMERO DA APÓLICE' valeu={customerCard?.policyNumber} />
                                                </Box>
                                            </Box>
                                        }
                                    </Box>
                                </BoxCard>
                                <BoxCard className='back-desk'>
                                    <IcMapCustomerCard />
                                    <Box padding='1.7rem 0 .75rem'>
                                        <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', gap: '.5rem' }}>
                                            <IcHeadset style={{ position: 'relative', width: 'auto', maxHeight: '1.5rem' }} />
                                            <Typography fontSize='.75rem' fontWeight={700} color='white' zIndex='1'>
                                                ROUBO E FURTO
                                            </Typography>
                                            <Typography fontSize='1.51rem' fontWeight={900} color='white' zIndex='1'>
                                                {customerCard?.EmergencyPhone}
                                            </Typography>
                                        </Box>
                                        <Box sx={{
                                            height: '1px',
                                            width: '1.31rem',
                                            margin: '1rem auto 1.2rem',
                                            borderRadius: '100px',
                                            justifyContent: 'center',
                                            backgroundColor: 'secondary.main',
                                        }} />
                                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: '.8rem' }}>
                                            <Box>
                                                <Typography fontSize='.4375rem' fontWeight={700} color='white' paddingBottom='4px' zIndex='1'>
                                                    SÃO PAULO
                                                </Typography>
                                                <Typography fontSize='.75rem' fontWeight={900} color='white' zIndex='1'>
                                                    {customerCard?.SACPhoneSP}
                                                </Typography>
                                            </Box>

                                            <Box>
                                                <Typography fontSize='.4375rem' fontWeight={700} color='white' paddingBottom='4px' zIndex='1'>
                                                    DEMAIS LOCALIDADES
                                                </Typography>
                                                <Typography fontSize='.75rem' fontWeight={900} color='white' zIndex='1'>
                                                    {customerCard?.SACPhoneOthers}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Typography fontSize='.4375rem' fontWeight={700} color='white' sx={{
                                            position: 'absolute',
                                            bottom: '.75rem',
                                            display: 'flex',
                                            left: '0',
                                            right: '0',
                                            justifyContent: 'center',
                                        }}>
                                            WWW.ITURAN.COM.BR
                                        </Typography>
                                    </Box>
                                </BoxCard>
                            </Box>
                        </Box>
                    </ContentCards>


                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        'button': {
                            maxWidth: '12rem'
                        },
                        padding: '0 0 2.25rem'
                    }}>

                        <Box sx={{
                            display: {
                                xs: 'none',
                                md: 'flex'
                            }
                        }}>
                            <ButtonOutlined name="IMPRIMIR CARTÃO" onClick={() => handlePrint()} />
                        </Box>
                        <Box sx={{
                            display: {
                                xs: 'flex',
                                md: 'none'
                            },
                            'button': {
                                width: '10rem'
                            }
                        }}>
                            <ButtonRectangle name="DOWNLOAD" onClick={() => handlePrint()} />
                        </Box>

                    </Box>
                </Box>
            </Box>
        </Modal>
    );
}

export default ModalCustomerCard;